import request from '@/utils/request'
import JsonBigint from 'json-bigint'

const api = {
  UploadLibraryImage: 'dragon/upload/uploadLibraryImage',
  GetThresholdFlagSwitch: 'dragon/app/getThresholdFlagSwitch',
  GetAllVirtualProduct: 'dragon/product/getAllVirtualProduct',
  Auth: 'web-api/index/auth',
  PunishList: 'web-api/index/punishList',
  CollectInfo: '/web-api/index/collectInfo',
  NetNoticeList: '/web-api/index/netNoticeList',
  NetNoticeInfo: '/web-api/index/netNoticeInfo'
}


export function punishList () {
  return request({
    url: api.PunishList,
    method: 'get'
  })
}

export function collectInfo (param) {
  return request({
    url: api.CollectInfo,
    method: 'get',
    params: param
  })
}

export function netNoticeList (param) {
  return request({
    url: api.NetNoticeList,
    method: 'get',
    params: param,
    transformResponse: [data => {
      data = JsonBigint.parse(data)
      data.data.list.filter(item => {
        item.id = item.id.toString()
        return item
      })
      return data
    }]
  })
}

export function netNoticeInfo (id) {
  return request({
    url: api.NetNoticeInfo + '/' + id,
    method: 'get'
  })
}
